// src/components/ReusableRightDrawer.jsx
import React from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import { Add } from "iconsax-react";

/**
 * ReusableRightDrawer
 * - Fixed header
 * - Scrollable content body
 * - Optional footer
 */
export default function ReusableRightDrawer({
  open,
  onClose,
  id,
  width = 546,
  headerLeft = null,
  headerRight = null,
  closeVariant = "text",
  closeColor = "#9C4FFF",
  paperSx = {},
  footer = null,
  children,
}) {
  const showDefaultClose = !headerRight;

  const closeBtnSx = {
    width: 22,
    height: 22,
    borderRadius: "50%",
    backgroundColor: closeColor, // ✅ purple background like screenshot
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: closeColor,
      opacity: 0.9,
    },
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      data-id={id}
      PaperProps={{
        sx: {
          width: { xs: "100vw", sm: width },
          maxWidth: "100vw",
          borderRadius: { xs: "0", sm: "16px 0 0 16px" },
          overflow: "hidden",
          boxShadow: "0 18px 45px rgba(2, 6, 23, 0.22)",
          ...paperSx,
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          backgroundColor: "#fff",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            flex: "0 0 auto",
            px: 2,
            py: 1.25,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #EEF2F7",
            backgroundColor: "#fff",
          }}
        >
          <Box sx={{ minWidth: 0, display: "flex", alignItems: "center", gap: 1 }}>
            {headerLeft}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {headerRight ? (
              headerRight
            ) : showDefaultClose ? (
              <IconButton onClick={onClose} size="small" sx={closeBtnSx}>
                {/* ✅ Iconsax has no "Close" export: rotate Add to make an "X" */}
                <Add
                  size="12"
                  color="#ffffff"
                  variant="Linear"
                  style={{ transform: "rotate(45deg)", display: "block" }}
                />
              </IconButton>
            ) : null}
          </Box>
        </Box>

        {/* Scrollable body */}
        <Box
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            px: 2,
            py: 2,
            WebkitOverflowScrolling: "touch",
          }}
        >
          {children}
        </Box>

        {/* Footer */}
        {footer ? (
          <Box
            sx={{
              flex: "0 0 auto",
              borderTop: "1px solid #EEF2F7",
              backgroundColor: "#fff",
              px: 2,
              py: 1.25,
            }}
          >
            {footer}
          </Box>
        ) : null}
      </Box>
    </Drawer>
  );
}